import React, { Fragment, useEffect, useState } from "react";
import "../templateform/templateform.css";
import Accordion from "react-bootstrap/Accordion";
import { apiCall, failedMessage, successMessage } from "../../utils/httpClient";
import apiEndPoint from "../../utils/apiEndPoint";
// import moment from "moment";
import Personalinformation from "./Component/personalInformation";
import About from "./Component/about";
import Portfolio from "./Component/portfolio";
import Professionalskills from "./Component/professionalSkills";
import Service from "./Component/service";
import Education from "./Component/education";
import Workexperience from "./Component/workExperience";
import Achievement from "./Component/achievement";
import { loadFromLocalStorage, saveToLocalStorage } from "../../utils/LocalStorageUtils";
import { Form, useNavigate } from "react-router-dom";
import { Button, Image, Modal, Spinner } from "react-bootstrap";
import Products from "./Component/Products";
import PricingPlans from "./Component/PricingPlans";
import IncrementSection from "./Component/IncrementSection";
import Testimonials from "./Component/testimonials";
import TeamMembers from "./Component/TeamMembers";
import AddBlog from "./Component/AddBlog";
import AddVideos from "./Component/AddVideos";
import { isEmpty } from "utils/utils";
import Domain from "./Component/domain";
import DomainPlan from "./Component/domainPlan";
import Header from "layout/header";
import DomainSelection from "pages/selectdomain";
import Footer from "layout/footer";

export default function Templateform() {
  const navigate = useNavigate();
  const [selectShowModule, setSelectShowModule] = useState('form')//form, selectDomain, checkout
  const [categoriesKeys, setCategoriesKeys] = useState(null)
  const [isLoading, setLoading] = useState(false);
  const [isLoadingSubmit, setLoadingSubmit] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [isLoadingPreview, setLoadingPreview] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [activeTab, setActiveTab] = useState("Desktop");
  const [saveForm, setSaveForm] = useState(false);
  const [showPageModule, setShowPageModule] = useState(0);//1='save',2='preview',3='publish'
  const [formDetail, setFormDetail] = useState(null)
  const [defaultFormDetail, setDefaultFormDetail] = useState(null)
  const [orderDetail, setOrderDetail] = useState(null)
  const [documentFile, setDocumentFile] = useState(null)
  const [profileImage, setProfileImage] = useState(null)
  const [logoImage, setLogoImage] = useState(null)
  const [bannerImage, setBannerImage] = useState(null)
  const [aboutMedia, setAboutMedia] = useState(null)
  const [showTamplateLink, setShowTamplateLink] = useState('')
  const [contactBy, setContactBy] = useState([])
  const [domainSelectShow, setDomainSelectShow] = useState(0)
  const [userData, setUserData] = useState({});
  const authData = loadFromLocalStorage("AUTH_DATA");
  const handleShow = () => setShow(true);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  useEffect(() => {
    if (authData) {
      setUserData(authData.userDetail)
    }
  }, [])
  const [languageData, setLanguageData] = useState(null);
  const selectLang = loadFromLocalStorage("SELECTLANGUAGE");
  useEffect(() => {
    setLanguageData(selectLang?.language)
  }, [selectLang])

  const handleBackButtonClick = () => {
    navigate(-1); // Navigate to the previous page
  };

  const [workingHours, setWorkingHours] = useState({
    status: true,
    hours: [
      { day: 'Monday', open: '', close: '' },
      { day: 'Tuesday', open: '', close: '' },
      { day: 'Wednesday', open: '', close: '' },
      { day: 'Thursday', open: '', close: '' },
      { day: 'Friday', open: '', close: '' },
      { day: 'Saturday', open: '', close: '' },
      { day: 'Sunday', open: '', close: '' },
    ],
  });
  const [portfolio, setPortfolio] = useState({
    description: {
      status: true,
      value: "",
    },
    headingTitle: {
      status: true,
      value: "",
    },
    items: [
      {
        description: "",
        image: "",
        status: false,
        title: "",
        link: "",
      },
    ],
    status: true,
  });
  const [sociallinks, setSociallinks] = useState([
    {
      social: "",
      link: "",
    },
  ]);
  const [professionallinks, setProfessionallinks] = useState([
    {
      skill: "",
      percentage: "",
    },
  ]);

  const [services, setServices] = useState({
    description: {
      status: true,
      value: "",
    },
    headingTitle: {
      status: true,
      value: "",
    },
    items: [
      {
        service_desc: "",
        status: true,
        title: "",
      },
    ],
    status: true,
  });
  const [reference, setReference] = useState([
    {
      name: "",
      designation: "",
      comment: "",
    },
  ]);

  const [education, setEducation] = useState({
    description: {
      status: true,
      value: "",
    },
    headingTitle: {
      status: true,
      value: "",
    },
    items: [
      {
        degree: "",
        description: "",
        status: false,
        university: "",
        yearOfPassing: "",
      },
    ],
    status: true,
  });

  const [work, setWork] = useState({
    description: {
      status: true,
      value: "",
    },
    headingTitle: {
      status: true,
      value: "",
    },
    items: [
      {
        companyName: "",
        description: "",
        designation: "",
        experience: "",
        status: false,
        year: "",
      },
    ],
    status: true,
  });
  const [products, setProducts] = useState({
    description: {
      status: true,
      value: "",
    },
    headingTitle: {
      status: true,
      value: "",
    },
    items: [
      {
        title: "",
        description: "",
        price: "",
        image: "",
        status: false,
      },
    ],
    status: true,
  });
  const [pricingPlans, setPricingPlans] = useState({
    description: {
      status: true,
      value: "",
    },
    headingTitle: {
      status: true,
      value: "",
    },
    items: [
      {
        heading: "",
        subheading: "",
        price: "",
        description: "",
        button_text: "",
        status: false,
      },
    ],
    status: true,
  });
  const [incrementSection, setIncrementSection] = useState({
    items: [
      {
        counter_number: "",
        description: "",
        status: false,
      },
    ],
    status: true,
  });
  const [testimonials, setTestimonials] = useState({
    items: [
      {
        name: "",
        designation: "",
        description: "",
        status: false,
      },
    ],
    status: true,
  });
  const [teamMembers, setTeamMembers] = useState({
    "description": {
      "status": true,
      "value": ""
    },
    "headingTitle": {
      "status": true,
      "value": ""
    },
    "items": [{
      status: '',
      name: '',
      designation: '',
      description: '',
      image: '',
    }],
    "status": true
  });
  const [addVideos, setAddVideos] = useState({
    "headingTitle": {
      "status": true,
      "value": ""
    },
    "items": [{
      status: '',
      title: '',
      video: '',
    }],
    "status": true
  });
  const [addBlog, setAddBlog] = useState({
    // "description": {
    //   "status": true,
    //   "value": ""
    // },
    "headingTitle": {
      "status": true,
      "value": ""
    },
    "items": [{
      status: '',
      title: '',
      link: '',
      description: '',
      image: '',
    }],
    "status": true
  });
  const [achievements, setAchievements] = useState({
    description: {
      value: "",
      status: true,
    },
    headingTitle: {
      status: true,
      value: "",
    },
    items: [
      {
        comment: "",
        description: "",
        name: "",
        status: false,
      },
    ],
    status: true,
  });

  useEffect(() => {
    getCategoryFormFilds();
  }, []);

  async function getCategoryFormFilds() {
    setLoading(true)
    const selctItm = loadFromLocalStorage("selectTemplate");
    const selctOrder = loadFromLocalStorage("selectOrderDetail");

    if (selctItm || selctOrder) {
      let header = { token: authData?.token }

      // var { data } = await apiCall("post", apiEndPoint.GETTEMPLATEFORMDETAIL, params, header);
      if (!isEmpty(selctOrder)) {
        let params = { order_id: selctOrder._id }
        var { data } = await apiCall("post", apiEndPoint.GETORDERDETAIL, params, header);
        setOrderDetail(data?.data)
      }
      if (!isEmpty(selctItm)) {
        let params = { template_id: selctItm._id }
        var { data } = await apiCall("post", apiEndPoint.GETTEMPLATEFORMDETAIL, params, header);
      }

      if (data.status === 200) {
        setCategoriesKeys(data.data.form_keys);
        setFormDetail(data.data.form_detail);
        setDefaultFormDetail(data.data.form_detail);
        const { form_detail } = data.data || {};

        if (!isEmpty(form_detail.portfolioSection)) {
          setPortfolio(form_detail.portfolioSection);
        }

        if (!isEmpty(form_detail.socialLinks))
          setSociallinks(form_detail.socialLinks);

        if (!isEmpty(form_detail.skillSection))
          setProfessionallinks(form_detail.skillSection);

        if (!isEmpty(form_detail.serviceSection))
          setServices(form_detail.serviceSection);

        if (!isEmpty(form_detail.references)) {
          if (!isEmpty(selctOrder))
            setReference(form_detail.references);
          if (!isEmpty(selctItm))
            setReference(JSON.parse(form_detail.references));
        }

        if (!isEmpty(form_detail.educationSection))
          setEducation(form_detail.educationSection);

        if (!isEmpty(form_detail.experienceSection))
          setWork(form_detail.experienceSection);

        if (!isEmpty(form_detail?.working_hours))
          setWorkingHours(form_detail?.working_hours);

        if (!isEmpty(form_detail.achievementSection))
          setAchievements(form_detail.achievementSection);
        if (!isEmpty(form_detail.products))
          setProducts(form_detail.products);
        if (!isEmpty(form_detail.pricing_plans))
          setPricingPlans(form_detail.pricing_plans);
        if (!isEmpty(form_detail.increment_section))
          setIncrementSection(form_detail.increment_section);
        if (!isEmpty(form_detail.testimonials))
          setTestimonials(form_detail.testimonials);
        if (!isEmpty(form_detail.team_members))
          setTeamMembers(form_detail.team_members);
        if (!isEmpty(form_detail.blog))
          setAddBlog(form_detail.blog);
        if (!isEmpty(form_detail.videos))
          setAddVideos(form_detail.videos);
        if (!isEmpty(form_detail.contact_by)) {
          const contactBy = Array.isArray(form_detail.contact_by)
            ? form_detail.contact_by : [form_detail.contact_by]
          setContactBy(contactBy);
        }
      } else {
        failedMessage(data.message);
      }
    }
    setLoading(false)
  }

  const addNewReference = () => {
    let newOdj = {
      name: "",
      designation: "",
      comment: "",
    };
    setReference([...reference, newOdj]);
  };
  const removeReference = (index) => {
    let newArr = [...reference];
    if (newArr.length > 1) {
      newArr.splice(index, 1);
    }
    setReference(newArr);
  };

  async function formSubmit(order_type, isPreview = false, formSave = 0) {

    const selctItm = loadFromLocalStorage("selectTemplate");
    const selctOrder = loadFromLocalStorage("selectOrderDetail");
    const formData = new FormData();

    if (!isEmpty(selctOrder)) {
      formData.append("category_id", selctOrder.category_id);
      formData.append("template_id", selctOrder?.template_id != undefined && !isEmpty(selctOrder?.template_id) ? selctOrder?.template_id : selctOrder?._id);
      formData.append("order_type", Number(order_type));
    }
    if (!isEmpty(selctItm)) {
      formData.append("category_id", selctItm?.category_id);
      formData.append("template_id", selctItm?._id);
      formData.append("order_type", order_type);
    }
    if (profileImage !== null) {
      formData.append("profile_image", profileImage[0]);
    } else {
      if (formDetail?.profile_image != undefined && formDetail?.profile_image != '') {
        const prourlObj = new URL(formDetail?.profile_image);
        const propathname = prourlObj.pathname.slice(1);
        if (categoriesKeys?.profile != undefined && categoriesKeys?.profile) {
          formData.append("profile_url", propathname);
        } else if (categoriesKeys?.about_media != undefined && categoriesKeys?.about_media) {
          formData.append("about_url", propathname);
        }
      }
    }
    if (documentFile !== null) {
      formData.append("cv_link", documentFile[0]);
    } else {
      if (formDetail?.cv_link != undefined && formDetail?.cv_link != '') {
        const urlObj = new URL(formDetail?.cv_link);
        const pathname = urlObj.pathname.slice(1);
        formData.append("cv_link_url", pathname);
      }
    }
    if (logoImage !== null) {
      formData.append("logo", logoImage[0]);
    } else {
      if (formDetail?.logo != undefined && formDetail?.logo != '') {
        const urlObj = new URL(formDetail?.logo);
        const pathname = urlObj.pathname.slice(1);
        formData.append("logo_url", pathname);
      }
    }
    if (bannerImage !== null) {
      formData.append("banner_image", bannerImage[0]);
    } else {
      formData.append("banner_url", formDetail?.banner_image);
    }
    if (aboutMedia !== null) {
      formData.append("about_media", aboutMedia[0]);
    }

    if (formDetail.order_id !== undefined && formDetail.order_id !== '') {
      formData.append("order_id", formDetail.order_id);
    }
    const appendIfDefined = (key, value) => {
      if (value !== undefined) {
        formData.append(key, JSON.stringify(value));
      }
    };
    appendIfDefined("cv_button_name", formDetail?.cv_button_name);
    appendIfDefined("name", formDetail.name);
    appendIfDefined("company_name", formDetail.company_name);
    appendIfDefined("company_tagline", formDetail.company_tagline);
    appendIfDefined("phone", formDetail.phone);
    appendIfDefined("email", formDetail.email);
    appendIfDefined("cv_status", formDetail.cv_status);
    appendIfDefined("address", formDetail.address);
    appendIfDefined("profession", formDetail.profession);
    appendIfDefined("aboutus", formDetail.aboutus);
    appendIfDefined("logo_status", formDetail.logo_status);
    appendIfDefined("portfolioSection", portfolio);
    appendIfDefined("educationSection", education);
    appendIfDefined("experienceSection", work);
    appendIfDefined("references", reference);
    appendIfDefined("serviceIcon", formDetail.serviceIcon);
    appendIfDefined("serviceSection", services);
    appendIfDefined("skillSection", professionallinks);
    appendIfDefined("socialLinks", sociallinks);
    appendIfDefined("achievementSection", achievements);
    appendIfDefined("products", products);
    appendIfDefined("pricing_plans", pricingPlans);
    appendIfDefined("increment_section", incrementSection);
    appendIfDefined("testimonials", testimonials);
    appendIfDefined("team_members", teamMembers);
    appendIfDefined("blog", addBlog);
    appendIfDefined("videos", addVideos);
    appendIfDefined("working_hours", workingHours);
    appendIfDefined("contact_by", contactBy);

    setLoadingSubmit(true)
    const headers = { "Content-Type": "application/x-www-form-urlencoded" };
    const { data } = await apiCall('post', apiEndPoint.ADDORDER, formData, headers);
    if (data.status === 200) {
      // setShowTemplateForm(false);
      successMessage(data.message);
      setFormDetail({ ...formDetail, order_id: data.data.order_id, order_type: data.data.order_type })
      if (order_type === 1 && isPreview) {
        // window.open(data?.data?.template_path, '_blank');
        setShowTamplateLink(data?.data?.template_path);
        setShowModal(true);
      }
      if (formSave === 1) {
        setSelectShowModule('selectDomain')
      }
      setSaveForm(true)

      saveToLocalStorage("selectTemplate", null);
      // if (!isEmpty(orderDetail))
      saveToLocalStorage("selectOrderDetail", data.data);
    } else {
      failedMessage(data.message);
      // setBusinessType(data.data)
    }
    setLoadingPreview(false);
    setLoadingSubmit(false)
    setUpdateLoading(false)
  }
  const handleSelectTypeContact = val => {
    let arr = contactBy || [];
    if (arr.some(i => i === val)) {
      arr = arr.filter(i => i !== val);
    } else {
      arr.push(val);
    }
    setContactBy([...arr]);
  };

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };

  const handleViewClick = (template) => {
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setShowModal(false);
  };
  const updateForm = () => {
    setUpdateLoading(true)
    let order_type = 1
    if (formDetail?.order_type !== undefined && formDetail?.order_type != '') {
      order_type = formDetail?.order_type
    }
    formSubmit(order_type, true, 0)
  };
  const handleBackPage = () => {
    setSelectShowModule('form')
  };

  const handleResetData = async (keyname = '') => {

    const selctItm = loadFromLocalStorage("selectTemplate");
    const selctOrder = loadFromLocalStorage("selectOrderDetail");
    if (selctItm || selctOrder) {

      let header = { token: authData?.token }

      // var { data } = await apiCall("post", apiEndPoint.GETTEMPLATEFORMDETAIL, params, header);
      if (!isEmpty(selctOrder)) {
        let params = { order_id: selctOrder._id }
        var { data } = await apiCall("post", apiEndPoint.GETORDERDETAIL, params, header);
        setOrderDetail(data?.data)
      }
      if (!isEmpty(selctItm)) {
        let params = { template_id: selctItm._id }
        var { data } = await apiCall("post", apiEndPoint.GETTEMPLATEFORMDETAIL, params, header);
      }

      if (data.status === 200) {
        setDefaultFormDetail(data.data.form_detail);
        const { form_detail } = data.data || {};

        if (keyname === 'portfolioSection') {
          setPortfolio(form_detail.portfolioSection);
        }
        if (keyname === 'skillSection')
          setProfessionallinks(form_detail.skillSection);
        if (keyname === 'serviceSection')
          setServices(form_detail.serviceSection);

        if (keyname === 'educationSection')
          setEducation(form_detail.educationSection);

        if (keyname === 'experienceSection')
          setWork(form_detail.experienceSection);
        if (keyname === 'products')
          setProducts(form_detail.products);
        if (keyname === 'pricing_plans')
          setPricingPlans(form_detail.pricing_plans);


        if (keyname === 'achievementSection')
          setAchievements(form_detail.achievementSection);
        if (keyname === 'products')
          setProducts(form_detail.products);
        if (keyname === 'increment_section')
          setIncrementSection(form_detail.increment_section);
        if (keyname === 'testimonials')
          setTestimonials(form_detail.testimonials);
        if (keyname === 'team_members')
          setTeamMembers(form_detail.team_members);
        if (keyname === 'blog')
          setAddBlog(form_detail.blog);
        if (keyname === 'videos')
          setAddVideos(form_detail.videos);
        if (keyname === 'working_hours')
          setWorkingHours(form_detail?.working_hours);


      }
    }

  };


  return (
    <Fragment>
      <div>
        {selectShowModule === 'form' &&
          <div>
            <div className="services-section mt-5">
              <div className="container text-center">
                <h1 className="animate__animated animate__bounce" style={{ fontFamily: 'quicksand', fontWeight: 600, textAlign: 'center', margin: 'auto' }}>
                  {languageData?.editWebsite}
                </h1>
                <br />
                <p style={{ fontSize: 16, fontWeight: 600, maxWidth: 900, margin: 'auto', color: '#444' }}>
                  {languageData?.createAWebsiteThatsUniquelyYours}
                </p>
              </div>
            </div>
            <div className="container mt-5">
              <div style={{ textAlign: 'center' }} className="mobile_video_btn">
                <button className="btn mobile_video_btn mx-auto mx-md-0 ms-md-auto"
                  style={{
                    borderRadius: 15,
                    width: 'fit-content',
                    fontSize: 12,
                    background: '#06038d',
                    color: '#fff',
                    fontWeight: 500,
                  }} onClick={handleShow}><i class="fa fa-play" style={{ paddingRight: 10 }} aria-hidden="true"></i>Instruction Video</button>{" "}
              </div>
              <div className="d-flex my-4 gap-3 gap-md-4 justify-content-center justify-content-md-start">
                {/* <Button onClick={() => { domainSelectShow === 0 ? handleBackButtonClick() : domainSelectShow === 1 ? setDomainSelectShow(0) : domainSelectShow === 2 ? setDomainSelectShow(1) : handleBackButtonClick() }} style={{ borderRadius: 15, width: 'fit-content', fontSize: 12, background: '#ff966a', color: '#000', fontWeight: 500, marginBottom: 20 }}>{'<'} {languageData?.back}</Button> */}
                <Button className="p-2 py-1 p-md-2 px-md-3" onClick={() => { domainSelectShow === 0 ? handleBackButtonClick() : domainSelectShow === 1 ? setDomainSelectShow(0) : domainSelectShow === 2 ? setDomainSelectShow(1) : handleBackButtonClick() }} style={{ borderRadius: 50, width: 'fit-content', fontSize: 12, background: '#ff966a', color: '#000', fontWeight: 500, }}>{'<'} {languageData?.back}</Button>
                {formDetail?.order_id === undefined ?
                  <>
                    <Button className="p-2 py-1 p-md-2 px-md-3"
                      style={{ borderRadius: 50, width: 'fit-content', fontSize: 12, background: '#ff966a', color: '#000', fontWeight: 500 }}
                      size='md' onClick={() => { formSubmit(1, true, 0); setShowPageModule(1) }}>{isLoadingSubmit && showPageModule === 1 && <Spinner animation="border" size="sm" role="status" />}{" "}{languageData?.save}</Button>
                    <Button className="p-2 py-1 p-md-2 px-md-3"

                      style={{ borderRadius: 50, width: 'fit-content', fontSize: 12, background: '#ff966a', color: '#000', fontWeight: 500 }}
                      size='md' onClick={() => { setLoadingPreview(true); formSubmit(1, true, 0); setShowPageModule(2) }}>{isLoadingSubmit && showPageModule === 2 && <Spinner animation="border" size="sm" role="status" />}{" "}{languageData?.savePreview}</Button>
                    {(userData?.subscription == undefined || !userData?.subscription) &&
                    <Button className="p-2 py-1 p-md-2 px-md-3"

                      style={{ borderRadius: 50, width: 'fit-content', fontSize: 12, background: '#ff966a', color: '#000', fontWeight: 500 }}
                      onClick={() => formSubmit(1, false, 1)} size='md'>{languageData?.publish}</Button>
                     }
                  </>
                  :
                  <div className="d-flex gap-4">
                    <Button className="p-2 py-1 p-md-2 px-md-3" style={{ borderRadius: 50, width: 'fit-content', fontSize: 12, background: '#ff966a', color: '#000', fontWeight: 500 }} size='md' onClick={() => updateForm()}>{updateLoading && <Spinner animation="border" size="sm" role="status" />}{" "}{languageData?.update}</Button>
                    <Button className="p-2 py-1 p-md-2 px-md-3" style={{ borderRadius: 50, width: 'fit-content', fontSize: 12, background: '#ff966a', color: '#000', fontWeight: 500 }}
                      size='md' onClick={() => { setLoadingPreview(true); formSubmit(1, true, 0); setShowPageModule(2) }}>{isLoadingSubmit && showPageModule === 2 && <Spinner animation="border" size="sm" role="status" />}{" "}{languageData?.savePreview}</Button>
                    {orderDetail?.order_status === 'draft' && (userData?.subscription == undefined || !userData?.subscription) &&
                      <Button className="p-2 py-1 p-md-2 px-md-3" style={{ borderRadius: 50, width: 'fit-content', fontSize: 12, background: '#ff966a', color: '#000', fontWeight: 500 }} size='md' onClick={() => setSelectShowModule('selectDomain')}>{languageData?.publish}</Button>
                    }
                  </div>
                }

                <button style={{ marginLeft: 'auto', borderRadius: 50, width: 'fit-content', fontSize: 12, background: '#06038d', color: '#fff', fontWeight: 500 }} onClick={handleShow} className="btn desktop_video_btn"><i class="fa fa-play" style={{ paddingRight: 10 }} aria-hidden="true"></i>Instruction Video</button>{" "}
              </div>
              <Modal show={show} onHide={handleClose} size="lg" centered>
                <Modal.Header closeButton>
                  <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <iframe width="100%" height="400" src="https://www.youtube.com/embed/8LSt8_11wbQ?si=ne27j8Gm_bu_-fg1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </Modal.Body>
              </Modal>
              {/* <Button onClick={() => { domainSelectShow === 0 ? navigate('/ourtemplate') : domainSelectShow === 1 ? setDomainSelectShow(0) : domainSelectShow === 2 ? setDomainSelectShow(1) : navigate('/ourtemplate') }} className="back-btn mt-4 mb-4">{'<'} Back</Button> */}
              {isLoading ? <center style={{ paddingTop: '10%' }}>
                <Spinner animation="border" role="status" />
              </center> :
                <div className="banner-div">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="banner-txt">
                      </div>
                      {!isEmpty(categoriesKeys) ?
                        (<div className="card">
                          {domainSelectShow === 0 ?
                            <div className="card-body">
                              <form>
                                <div className="form-group">
                                  <Accordion defaultActiveKey="0">
                                    <Accordion.Item className="mt-acc" eventKey="0">
                                      <Personalinformation
                                        setSociallinks={setSociallinks}
                                        sociallinks={sociallinks}
                                        categoriesKeys={categoriesKeys}
                                        setFormDetail={setFormDetail}
                                        formDetail={formDetail}
                                        documentFile={documentFile}
                                        setDocumentFile={setDocumentFile}
                                        profileImage={profileImage}
                                        setProfileImage={setProfileImage}
                                        logoImage={logoImage}
                                        setLogoImage={setLogoImage}
                                        bannerImage={bannerImage}
                                        setBannerImage={setBannerImage}
                                        workingHours={workingHours}
                                        setWorkingHours={setWorkingHours}
                                        aboutMedia={aboutMedia}
                                        setAboutMedia={setAboutMedia}
                                        languageData={languageData}
                                      />
                                    </Accordion.Item>
                                    {categoriesKeys.about_description === true && (
                                      <Accordion.Item className="mt-acc" eventKey="1">
                                        <About
                                          setFormDetail={setFormDetail}
                                          formDetail={formDetail}
                                          defaultFormDetail={defaultFormDetail}
                                          languageData={languageData}
                                        />
                                      </Accordion.Item>
                                    )}
                                    {categoriesKeys.portfolio === true && (
                                      <Accordion.Item className="mt-acc" eventKey="2">
                                        <Portfolio
                                          portfolio={portfolio}
                                          setPortfolio={setPortfolio}
                                          handleResetData={handleResetData}
                                          languageData={languageData}
                                        />
                                      </Accordion.Item>
                                    )}
                                    {categoriesKeys.skills === true && (
                                      <Accordion.Item className="mt-acc" eventKey="4">
                                        <Professionalskills
                                          professionallinks={professionallinks}
                                          setProfessionallinks={setProfessionallinks}
                                          setFormDetail={setFormDetail}
                                          formDetail={formDetail}
                                          languageData={languageData}
                                          handleResetData={handleResetData}
                                        />
                                      </Accordion.Item>
                                    )}
                                    {categoriesKeys.achievements_service === true && (
                                      <Accordion.Item className="mt-acc" eventKey="5">
                                        <Service
                                          services={services}
                                          setServices={setServices}
                                          languageData={languageData}
                                          handleResetData={handleResetData}
                                        />
                                      </Accordion.Item>
                                    )}
                                    {categoriesKeys.education === true && (
                                      <Accordion.Item className="mt-acc" eventKey="6">
                                        <Education
                                          education={education}
                                          setEducation={setEducation}
                                          languageData={languageData}
                                          handleResetData={handleResetData}
                                        />
                                      </Accordion.Item>
                                    )}
                                    {categoriesKeys.experience === true && (
                                      <Accordion.Item className="mt-acc" eventKey="7">
                                        <Workexperience work={work} setWork={setWork} languageData={languageData} handleResetData={handleResetData} />
                                      </Accordion.Item>
                                    )}
                                    {categoriesKeys.products === true && (
                                      <Accordion.Item className="mt-acc" eventKey="11">
                                        <Products data={products} setData={setProducts} languageData={languageData} handleResetData={handleResetData} />
                                      </Accordion.Item>
                                    )}
                                    {categoriesKeys.pricing_plans === true && (
                                      <Accordion.Item className="mt-acc" eventKey="12">
                                        <PricingPlans data={pricingPlans} setData={setPricingPlans} languageData={languageData} handleResetData={handleResetData} />
                                      </Accordion.Item>
                                    )}
                                    {categoriesKeys.increment_section === true && (
                                      <Accordion.Item className="mt-acc" eventKey="13">
                                        <IncrementSection data={incrementSection} setData={setIncrementSection} languageData={languageData} />
                                      </Accordion.Item>
                                    )}
                                    {categoriesKeys.testimonials === true && (
                                      <Accordion.Item className="mt-acc" eventKey="14">
                                        <Testimonials data={testimonials} setData={setTestimonials} languageData={languageData} handleResetData={handleResetData} />
                                      </Accordion.Item>
                                    )}
                                    {categoriesKeys.team_members === true && (
                                      <Accordion.Item className="mt-acc" eventKey="15">
                                        <TeamMembers data={teamMembers} setData={setTeamMembers} languageData={languageData} handleResetData={handleResetData} />
                                      </Accordion.Item>
                                    )}
                                    {categoriesKeys.blog === true && (
                                      <Accordion.Item className="mt-acc" eventKey="16">
                                        <AddBlog data={addBlog} setData={setAddBlog} languageData={languageData} handleResetData={handleResetData} />
                                      </Accordion.Item>
                                    )}

                                    {categoriesKeys.achievements === true && (
                                      <Accordion.Item className="mt-acc" eventKey="8">
                                        <Achievement
                                          achievements={achievements}
                                          setAchievements={setAchievements}
                                          languageData={languageData}
                                          handleResetData={handleResetData}
                                        />
                                      </Accordion.Item>
                                    )}
                                    {categoriesKeys.reference === true && (
                                      <Accordion.Item className="mt-acc" eventKey="9">
                                        <Accordion.Header>
                                          <div className="drop_header_dflex">
                                            {languageData?.addReference}
                                            <label className="thm_switch__btn drop_swich_btn">
                                              <Form.Check
                                                defaultChecked={reference.status}
                                                style={{ marginRight: 20, display: 'inline-block', zIndex: 0 }}
                                                type="switch"
                                                className="custom-switch"
                                                onChange={(e) => setReference({
                                                  ...reference,
                                                  status: !reference.status
                                                })
                                                }
                                                onClick={(e) => e.stopPropagation()} // Prevent event bubbling
                                              />
                                              <span className="thm_switch_slider round"></span>
                                            </label>
                                          </div>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                          {reference && reference.length > 0 && reference.map((item, index) => (
                                            <div key={index}>
                                              <div className="row new_fild_shadow">
                                                {index > 0 && (
                                                  <div className="sav-proj-btn">
                                                    <button
                                                      className="cancel-btn"
                                                      onClick={() =>
                                                        removeReference(index)
                                                      }
                                                      type="button"
                                                    >
                                                      <i
                                                        className="fa fa-times"
                                                        aria-hidden="true"
                                                      ></i>
                                                    </button>
                                                  </div>
                                                )}
                                                <div className="col-lg-6">
                                                  <div className="input-field-box">
                                                    <label className="forn_title">
                                                      {languageData?.name}:
                                                    </label>
                                                    <input
                                                      placeholder="Enter details"
                                                      className="form-control"
                                                      value={item.name}
                                                    />
                                                  </div>
                                                </div>
                                                <div className="col-lg-6">
                                                  <div className="input-field-box">
                                                    <label className="forn_title">
                                                      {languageData?.designation}:
                                                    </label>
                                                    <input
                                                      placeholder="Enter..."
                                                      className="form-control"
                                                      value={item.designation}
                                                    />
                                                  </div>
                                                </div>
                                                <div className="col-lg-12">
                                                  <div className="input-field-box">
                                                    <label className="forn_title">
                                                      {languageData?.comment}:
                                                    </label>
                                                    <textarea
                                                      placeholder="Comment ..."
                                                      className="form-control pb-5"
                                                      value={item.comment}
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                              {index === reference.length - 1 && (
                                                <div className="sav-proj-btn">
                                                  <button
                                                    className="sub-btn"
                                                    onClick={addNewReference}
                                                    type="button"
                                                  >
                                                    {languageData?.addMore}
                                                  </button>
                                                </div>
                                              )}
                                            </div>
                                          ))}
                                        </Accordion.Body>
                                      </Accordion.Item>
                                    )}
                                    {categoriesKeys.videos === true && (
                                      <Accordion.Item className="mt-acc" eventKey="17">
                                        <AddVideos data={addVideos} setData={setAddVideos} languageData={languageData} handleResetData={handleResetData} />
                                      </Accordion.Item>
                                    )}
                                    {/* {categoriesKeys.contact_you_by === true && (
                                <Accordion.Item className="mt-acc" eventKey="10">
                                  <Accordion.Header>
                                    <div className="drop_header_dflex">
                                      <div>
                                        <img
                                          src="/assets/images/icon/contact.png"
                                          width={"17%"}
                                          alt="Contact"
                                        />{" "}
                                        Contact
                                      </div>
                                    </div>
                                  </Accordion.Header>
                                  <Accordion.Body>
                                    <div>
                                      <p>
                                        Where do you want to receive customer
                                        details when someone tries to contact you
                                        by filling out the contact form on your
                                        website ?
                                      </p>
                                      {CUSTOMER_CONTACT.map((item, index) => (
                                        <div key={index} className="d-flex mt-2">
                                          <input
                                            type="checkbox"
                                            className="contact_checkbox"
                                            id="vehicle1"
                                            name="vehicle1"
                                            checked={contactBy.some(i => i === item.name)}
                                            onChange={() => handleSelectTypeContact(item.name)}
                                          />{" "}
                                          <label
                                            htmlFor="vehicle1"
                                            className="forn_title"
                                          >
                                            {" "}
                                            {item.name}
                                          </label>
                                        </div>))}
                                    </div>
                                  </Accordion.Body>
                                </Accordion.Item>
                              )} */}
                                  </Accordion>

                                  <div className="sav-proj-btn">
                                    {/* <button className="sub-btn" type="button" onClick={formSubmit}>
                            Save Details
                          </button> */}

                                    {/* <button className="sub-btn" type="button" >
                                {isLoadingPreview ? <Spinner animation="border" size="sm" role="status" /> : 'Preview'}
                              </button>{" "} */}

                                    {/* <button className="sub-btn" type="button" onClick={() => { setDomainSelectShow(1); }}>
                                {isLoadingSubmit ? <Spinner animation="border" size="sm" role="status" /> : 'Submit'}
                                <button className="sub-btn" type="button" onClick={() => { setLoadingSubmit(true); formSubmit(2) }}>
                                {isLoadingSubmit ? <Spinnefalser animation="border" size="sm" role="status" /> : 'Submit'}
                              </button> */}
                                  </div>
                                </div>
                              </form>
                            </div> :
                            domainSelectShow === 1 ?
                              <Domain setDomainSelectShow={setDomainSelectShow} />
                              // <DomainSelect setDomainSelectShow={setDomainSelectShow} />
                              : domainSelectShow === 2 ?
                                <DomainPlan /> : ''
                          }
                        </div>)
                        : (
                          <center style={{ paddingTop: '15%' }}>
                            <h1>Oops!</h1>
                            <p>{languageData?.sorryAnUnexpectedErrorHasOccurred}.</p>
                            <Button onClick={() => window.location.reload()}>{languageData?.tryAgain}</Button>
                          </center>
                        )
                      }
                    </div>
                  </div>
                </div>}
              {/* Buttons */}
              <div className="d-flex my-4 gap-3 gap-md-4 justify-content-center justify-content-md-start">
                <Button className="p-2 py-1 p-md-2 px-md-3" onClick={() => { domainSelectShow === 0 ? handleBackButtonClick() : domainSelectShow === 1 ? setDomainSelectShow(0) : domainSelectShow === 2 ? setDomainSelectShow(1) : handleBackButtonClick() }} style={{ borderRadius: 15, width: 'fit-content', fontSize: 12, background: '#ff966a', color: '#000', fontWeight: 500 }}>{'<'} {languageData?.back}</Button>
                {formDetail?.order_id === undefined ?
                  <div className="d-flex gap-4">
                    <Button className="p-2 py-1 p-md-2 px-md-3"
                      style={{ borderRadius: 50, width: 'fit-content', fontSize: 12, background: '#ff966a', color: '#000', fontWeight: 500 }}
                      size='md' onClick={() => { formSubmit(1, true, 0); setShowPageModule(1) }}>{isLoadingSubmit && showPageModule === 1 && <Spinner animation="border" size="sm" role="status" />}{" "}{languageData?.save}</Button>
                    <Button className="p-2 py-1 p-md-2 px-md-3"
                      style={{ borderRadius: 50, width: 'fit-content', fontSize: 12, background: '#ff966a', color: '#000', fontWeight: 500 }}
                      size='md' onClick={() => { setLoadingPreview(true); formSubmit(1, true, 0); setShowPageModule(2) }}>{isLoadingSubmit && showPageModule === 2 && <Spinner animation="border" size="sm" role="status" />}{" "}{languageData?.savePreview}</Button>
                    {(userData?.subscription == undefined || !userData?.subscription) &&
                      <Button className="p-2 py-1 p-md-2 px-md-3"
                        style={{ borderRadius: 50, width: 'fit-content', fontSize: 12, background: '#ff966a', color: '#000', fontWeight: 500 }}
                        onClick={() => formSubmit(1, false, 1)} size='md'>{languageData?.publish}</Button>
                    }
                  </div>
                  :
                  <div className="d-flex gap-4">
                    <Button className="p-2 py-1 p-md-2 px-md-3" style={{ borderRadius: 50, width: 'fit-content', fontSize: 12, background: '#ff966a', color: '#000', fontWeight: 500 }} size='md' onClick={() => updateForm()}>{updateLoading && <Spinner animation="border" size="sm" role="status" />}{" "}{languageData?.update}</Button>
                    <Button className="p-2 py-1 p-md-2 px-md-3" style={{ borderRadius: 50, width: 'fit-content', fontSize: 12, background: '#ff966a', color: '#000', fontWeight: 500 }}
                      size='md' onClick={() => { setLoadingPreview(true); formSubmit(1, true, 0); setShowPageModule(2) }}>{isLoadingSubmit && showPageModule === 2 && <Spinner animation="border" size="sm" role="status" />}{" "}{languageData?.savePreview}</Button>
                    {orderDetail?.order_status === 'draft' && (userData?.subscription == undefined || !userData?.subscription) &&
                      <Button className="p-2 py-1 p-md-2 px-md-3" style={{ borderRadius: 50, width: 'fit-content', fontSize: 12, background: '#ff966a', color: '#000', fontWeight: 500 }} size='md' onClick={() => setSelectShowModule('selectDomain')}>{languageData?.publish}</Button>
                    }
                  </div>
                }
              </div>
            </div>

            {/* Modal for Viewing Template */}
            <Modal
              show={showModal}
              onHide={handleCloseModal}
              centered
              size={activeTab === "Desktop" ? "xl" : "md"} // Set modal size based on active tab
            >
              <Modal.Body>
                {/* <Nav variant="tabs" activeKey={activeTab} onSelect={(selectedTab) => setActiveTab(selectedTab)} className="justify-content-center text-center align-items-center">
              <Nav.Item>
                <Nav.Link eventKey="Desktop">
                  <FaDesktop className="me-2" />
                  Desktop
                </Nav.Link>
              </Nav.Item>
              <div className="nav-separator"></div> 
              <Nav.Item>
                <Nav.Link eventKey="Mobile">
                  <FaMobileAlt className="me-2" />
                  Mobile
                </Nav.Link>
              </Nav.Item>
            </Nav> */}
                {showPageModule === 1 &&
                  <div style={{ textAlign: 'center', paddingTop: '2rem', paddingBottom: '2rem' }}>
                    <p style={{ fontSize: '20px' }}><Image src='assets/images/icon/Checkmark.png' style={{ width: '35px' }} // Add pointer cursor for clickable effect
                    /> {languageData?.yourProgressHasBeenSaved}</p>
                  </div>
                }
                {showPageModule === 2 &&
                  <iframe src={showTamplateLink} width="100%" height="650"></iframe>
                }

                {showPageModule != 2 && showPageModule != 1 &&
                  <div style={{ textAlign: 'center', paddingTop: '2rem', paddingBottom: '2rem' }}>
                    <p style={{ fontSize: '20px' }}><Image src='assets/images/icon/Checkmark.png' style={{ width: '35px' }} // Add pointer cursor for clickable effect
                    /> {languageData?.yourProgressHasBeenSaved}</p>
                  </div>
                }


              </Modal.Body>
            </Modal>
          </div>
        }

        {selectShowModule === 'selectDomain' &&
          <div>
            <DomainSelection orderDetail={formDetail} handleBackPage={handleBackPage} />
          </div>
        }
      </div>
      <hr />
    </Fragment>
  );
}
